import { stateGo } from 'redux-ui-router';
import { __, filter, isNil, keys, max, pathOr, range } from 'ramda';
import { i18n, MetadataActions, MetadataConstants, MetadataSelectors, PermissionService, SessionSelectors } from 'invision-core';
import { CurrentCustomerIdSelector, CurrentCustomerSelector, RouteParams, RouteState } from '../../../../reducers/selectors/customer.selectors';
import { IsFetchingSingleProductContext, ViewLastAttemptErrorSelector } from './../../../../reducers/selectors/products.order.selectors';
import { applySubscriptionCoupon, cancelPendingOrder, removeSubscriptionDiscount, retrievePendingOrder, retrieveSubscription, setCurrentSubscriptionOfferingDetails, setEditSubscriptionItemId, setModifyRenewalSubscriptionItem, setSelectedDiscount, setSubscriptionCouponCode, updateSubscription } from '../../../../reducers/actions/customer.subscriptions.actions';
import { getOrderablePricingExtended, getProductMetadataBatch, goToCheckoutForRestoreSubscription, retrieveProductContext } from '../../../../reducers/actions/products.order.actions';
import { addToAndUpdateShoppingCart, reinitializeProductOrder } from '../../../../reducers/actions/products.wizard.actions';
import { ActiveAddressesWithCurrentSubscriptionAddressSelector, BackButtonRouteForSubscriptionDetailsSelector, BillingCycleSelector, BrandableCurrencyNameSelector, CurrencySelector, CurrentOfferIdSelector, CurrentSubscriptionIdSelector, CurrentSubscriptionOfferingDetailsSelector, CurrentSubscriptionSelector, IsCurrentSubscriptionOfferingPendingSelector, IsFetchingDataSelector, IsFetchingSubscriptionDetailsSelector, IsRemovingDiscountSelector, IsRetrievingPendingOrderSelector, IsUpdatingSubscriptionSelector, IsValidatingCouponSelector, OrderNumberSelector, OrderIdSelector, PendingOrderSelector, SelectedDiscountSelector,
// Commented to use ShippingAddressSelectorForSubscriptions as a workaround
// Because the API is not updating the ShipToName field PD-485248
// Should be used again once the endpoint SubscriberManagement/UpdateSubscription gets fixed
// ShippingAddressSelector,
ShippingAddressSelectorForSubscriptions, ShippingMethodNameSelector, ShowShippingInfoSelector, SubscriptionCouponCodeSelector, SubscriptionDetailMoreOptionsSelector, SubscriptionErrorSelector, UserCanRemoveDiscountSelector, UserCanRenewSelector, UserCanRestoreSubscriptionSelector, UserCanUpdateSubscriptionSelector, SubscriptionProductIdSelector } from '../../../../reducers/selectors/customer.subscriptions.selectors';
import * as SubscriptionConstants from '../../../shared/constants/subscriptions.constants';
import { SubscriptionItemsExtensionSelectors, SubscriptionProductsMoreOptionsMapSelector, SubscriptionWithDetailedItemsSelector } from '../../../../reducers/selectors/customer.subscriptions.products.selectors';
import CustomerCareLocaleKeys from './../../../../locales/keys';
import { retrieveAvailablePaymentInstrumentTypes, retrieveWallet, selectPaymentMethod } from '../../../../reducers/actions/customer.ewallet.actions';
import { EwalletErrorSelector, IsRetrievingEwalletDataSelector, PaymentInstrumentsCanBeUsedForOrderingWithTypeNamesViewModelSelector, SelectedPaymentMethodWithTypeNamesViewModelSelector } from '../../../../reducers/selectors/customer.ewallet.selectors';
import { isReadOnlyException } from '../../../../reducers/helpers/ewallet.reducer.helper';
import { CurrentMemberHasCreatePaymentInstrumentPermissionsSelector } from './../../../../reducers/selectors/customer.household.selectors';
import { E_WALLET_ADMIN_ACCESS, ORDERING_ACCESS } from '../../../../security.attributes';
import { setLockerFilter, showSubscriptionBanner } from '../../../../reducers/actions/customer.transactions.actions';
import { AddressesErrorSelector, IsFetchingAddressesSelector } from '../../../../reducers/selectors/customer.addresses.selectors';
import { retrieveCustomerAddresses } from '../../../../reducers/actions/customer.addresses.actions';
import { SUBSCRIPTION_DETAILS_ROUTE } from '../subscriptions.config';
import { setSelectedOfferName, startEditOfferFlow } from '../../../../reducers/actions/offering.order.actions';
import { STATE_NAME as TRANSITION_OFFER } from '../../orders/transition/transition.offer.wizard.constants';
import { DASHBOARD_ROUTE } from '../../../../reducers/constants/dashboard.constants';
import { OFFERING_OPTION_STATUSES } from '../../../shared/constants/offering.option.status.constants';
function SubscriptionDetailController($ngRedux, uiNotificationService, $timeout, $state) {
  var _this = this;
  var disconnectRedux;
  var mapStateToTarget = function mapStateToTarget(store) {
    return {
      addressError: AddressesErrorSelector(store),
      backRoute: BackButtonRouteForSubscriptionDetailsSelector(store),
      billingCycleName: BillingCycleSelector(store),
      brandableCurrencyName: BrandableCurrencyNameSelector(store),
      canRemoveDiscount: UserCanRemoveDiscountSelector(store),
      codeTypeLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(__, store),
      couponCode: SubscriptionCouponCodeSelector(store),
      currency: CurrencySelector(store),
      currentAddresses: ActiveAddressesWithCurrentSubscriptionAddressSelector(store),
      currentCustomerId: CurrentCustomerIdSelector(store),
      currentCustomer: CurrentCustomerSelector(store),
      currentMemberCanCreatePaymentInstrument: CurrentMemberHasCreatePaymentInstrumentPermissionsSelector(store),
      currentSubscription: CurrentSubscriptionSelector(store),
      currentSubscriptionOfferingDetails: CurrentSubscriptionOfferingDetailsSelector(store),
      discountRemoveReasonsLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.DiscountRemoveReason, store),
      discountRemoveReasonOptions: MetadataSelectors.codes.MetadataOptionsForCodeValuesSelector(MetadataConstants.codes.DiscountRemoveReason, store),
      eWalletError: EwalletErrorSelector(store),
      isCurrentSubscriptionOfferingPending: IsCurrentSubscriptionOfferingPendingSelector(store),
      isFetchingAddresses: IsFetchingAddressesSelector(store),
      isFetchingData: IsFetchingDataSelector(store),
      isFetchingEwalletData: IsRetrievingEwalletDataSelector(store),
      isFetchingSingleProductContext: IsFetchingSingleProductContext(store),
      isFetchingSubscriptionDetailsSelector: IsFetchingSubscriptionDetailsSelector(store),
      isRemovingDiscount: IsRemovingDiscountSelector(store),
      IsRetrievingPendingOrder: IsRetrievingPendingOrderSelector(store),
      isUpdatingSubscription: IsUpdatingSubscriptionSelector(store),
      isValidatingCoupon: IsValidatingCouponSelector(store),
      moreOptionsMenuItems: SubscriptionDetailMoreOptionsSelector(store),
      offerId: CurrentOfferIdSelector(store),
      orderNumber: OrderNumberSelector(store),
      orderId: OrderIdSelector(store),
      pendingOrder: PendingOrderSelector(store),
      paymentInstruments: PaymentInstrumentsCanBeUsedForOrderingWithTypeNamesViewModelSelector(store),
      productOrderError: ViewLastAttemptErrorSelector(store),
      routeParams: RouteParams(store),
      routeState: RouteState(store),
      selectedPaymentMethod: SelectedPaymentMethodWithTypeNamesViewModelSelector(store),
      selectedDiscount: SelectedDiscountSelector(store),
      showShippingInfo: ShowShippingInfoSelector(store),
      subscriptionError: SubscriptionErrorSelector(store),
      subscriptionId: CurrentSubscriptionIdSelector(store),
      subscriptionProductId: SubscriptionProductIdSelector(store),
      subscriptionItems: SubscriptionWithDetailedItemsSelector(store),
      subscriptionItemsExtensions: SubscriptionItemsExtensionSelectors(store),
      subscriptionItemsMoreOptionsMap: SubscriptionProductsMoreOptionsMapSelector(store),
      // Commented to use ShippingAddressSelectorForSubscriptions as a workaround
      // Because the API is not updating the ShipToName field PD-485248
      // Should be used again once the endpoint SubscriberManagement/UpdateSubscription gets fixed
      //subscriptionShippingAddress: ShippingAddressSelector(store),
      subscriptionShippingAddress: ShippingAddressSelectorForSubscriptions(store),
      subscriptionShippingMethod: ShippingMethodNameSelector(store),
      userCanRenew: UserCanRenewSelector(store),
      userCanRestoreSubscription: UserCanRestoreSubscriptionSelector(store),
      userCanUpdateSubscription: UserCanUpdateSubscriptionSelector(store),
      userSecurityAttributes: SessionSelectors.UserSecurityAttributesSelector(store)
    };
  };
  var controllerActions = {
    applySubscriptionCoupon: applySubscriptionCoupon,
    addToAndUpdateShoppingCart: addToAndUpdateShoppingCart,
    cancelPendingOrder: cancelPendingOrder,
    fetchCodeType: MetadataActions.codes.fetchCodeTypes,
    getProductMetadataBatch: getProductMetadataBatch,
    getShippingMethodsByCountryCode: MetadataActions.shippingMethods.getShippingMethodsByCountryCode,
    goToCheckoutForRestoreSubscription: goToCheckoutForRestoreSubscription,
    reinitializeProductOrder: reinitializeProductOrder,
    removeSubscriptionDiscount: removeSubscriptionDiscount,
    retrieveAvailablePaymentInstrumentTypes: retrieveAvailablePaymentInstrumentTypes,
    getOrderablePricingExtended: getOrderablePricingExtended,
    retrieveCustomerAddresses: retrieveCustomerAddresses,
    retrievePendingOrder: retrievePendingOrder,
    retrieveProductContext: retrieveProductContext,
    retrieveSubscription: retrieveSubscription,
    retrieveWallet: retrieveWallet,
    selectPaymentMethod: selectPaymentMethod,
    setCurrentSubscriptionOfferingDetails: setCurrentSubscriptionOfferingDetails,
    setEditSubscriptionItemId: setEditSubscriptionItemId,
    setLockerFilter: setLockerFilter,
    setModifyRenewalSubscriptionItem: setModifyRenewalSubscriptionItem,
    setSelectedDiscount: setSelectedDiscount,
    setSelectedOfferName: setSelectedOfferName,
    setSubscriptionCouponCode: setSubscriptionCouponCode,
    showSubscriptionBanner: showSubscriptionBanner,
    startEditOfferFlow: startEditOfferFlow,
    stateGo: stateGo,
    updateSubscription: updateSubscription
  };
  this.$onInit = function () {
    _this.metadataCodes = [MetadataConstants.codes.DiscountRemoveReason, MetadataConstants.codes.SubscriberProductPricingPlanChangeSource, MetadataConstants.codes.SubscriptionBillingRenewalType, MetadataConstants.codes.SubscriptionStateIndicator];
    _this.uiNotificationService = uiNotificationService;
    disconnectRedux = $ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
      _this.state = state;
      _this.actions = actions;
    });
    _this.resetCouponCode();
    _this.retrieveAddresses();
    _this.retrieveSubscription().then(function () {
      /**This logic handles restore page navigation from react subscription widget.
       * restore page route allows navigation only if redux state has subscription loaded thats the reason
       * added this logic here */
      if (_this.state.routeParams && _this.state.routeParams.goToCheckoutForRestoreSubscription) {
        _this.restoreSubscription();
      }
      if (_this.state.showShippingInfo && pathOr(false, ['subscriptionShippingAddress', 'Country'], _this.state)) {
        _this.actions.getShippingMethodsByCountryCode(_this.state.subscriptionShippingAddress.Country);
      }
      if (_this.state.subscriptionProductId) {
        _this.actions.getOrderablePricingExtended(_this.state.subscriptionProductId, _this.state.currentCustomerId).catch(function () {
          _this.uiNotificationService.error(i18n.translate(_this.localeKeys.PRODUCTS_ERROR), null, {
            timeOut: NOTIFICATION_TIME_LENGTH
          });
        });
      }
    });
    _this.localeKeys = CustomerCareLocaleKeys;
    _this.manualRenewal = i18n.translate(_this.localeKeys.SUBSCRIPTIONS.MANUAL_RENEWAL);
    _this.autoRenewal = i18n.translate(_this.localeKeys.SUBSCRIPTIONS.AUTOMATIC_RENEWAL);
    _this.willNotRenew = i18n.translate(_this.localeKeys.SUBSCRIPTIONS.WILL_NOT_RENEW);
    _this.stateOrName = SUBSCRIPTION_DETAILS_ROUTE;
    _this.optionalParams = {
      customerId: _this.state.currentCustomerId
    };
    _this.metadataCodes.forEach(function (code) {
      if (!_this.state.codeTypeLoaded(code)) {
        _this.actions.fetchCodeType(code);
      }
    });
    _this.actions.reinitializeProductOrder();
    _this.actions.retrieveAvailablePaymentInstrumentTypes().catch(function (error) {
      _this.uiNotificationService.transientError(error.translatedMessage);
    });
    _this.nextStepText = i18n.translate(_this.localeKeys.CONTINUE_TO_STEP, {
      step: i18n.translate(_this.localeKeys.WIZARD.STEPS.CHECKOUT)
    });
    _this.applyDiscountDialogApi = null;
    _this.applyDiscountDialogConfig = {
      onRegisterApi: function onRegisterApi(evt) {
        _this.applyDiscountDialogApi = Object.assign({}, evt.api, {
          open: function open() {
            _this.showDiscountForm = true;
            $timeout(function () {
              evt.api.open();
            });
          },
          close: function close() {
            _this.showDiscountForm = false;
            evt.api.close();
          }
        });
      }
    };
    _this.showEditModal = false;
    _this.removeDiscountModal = {
      onRegisterApi: function onRegisterApi(evt) {
        _this.removeDiscountModal = evt.api;
      }
    };
    _this.removeExtensionModalConfig = {
      onRegisterApi: function onRegisterApi(evt) {
        _this.removeExtensionModalApi = evt.api;
      }
    };
    _this.toggleModifyRenewalModal = false;
    _this.modifyRenewalModal = {
      onRegisterApi: function onRegisterApi(evt) {
        _this.modifyRenewalModal = evt.api;
      }
    };
    _this.cancelChangeModal = {
      onRegisterApi: function onRegisterApi(evt) {
        _this.cancelChangeModalApi = evt.api;
      }
    };
    _this.cancelRemovalModal = {
      onRegisterApi: function onRegisterApi(evt) {
        _this.cancelRemovalModalApi = evt.api;
      }
    };
  };
  this.onApplyCouponCode = function (couponCode) {
    _this.actions.setSubscriptionCouponCode({
      name: couponCode,
      description: null
    });
    return _this.applySubscriptionCoupon();
  };
  this.resetCouponCode = function () {
    _this.actions.setSubscriptionCouponCode(null);
  };
  this.handleMoreOptionsSelected = function (_ref, subscriptionItem) {
    var item = _ref.item;
    switch (item.id) {
      case SubscriptionConstants.APPLY_DISCOUNT_OPTION_ID:
        _this.openDiscountDialog();
        break;
      case SubscriptionConstants.CHANGE_SUBSCRIPTION_OFFER_OPTION_ID:
        _this.actions.setSelectedOfferName(_this.state.currentSubscriptionOfferingDetails.DisplayName);
        $state.go(TRANSITION_OFFER, {
          offeringId: _this.state.currentSubscriptionOfferingDetails.OfferingId
        });
        break;
      case SubscriptionConstants.MODIFY_SUBSCRIPTION:
        if (!isNil(subscriptionItem)) {
          _this.actions.setEditSubscriptionItemId(subscriptionItem.Id);
        }
        _this.showEditModal = true;
        break;
      case SubscriptionConstants.REMOVE_SUBSCRIPTION_OPTION_ID:
        if (!isNil(subscriptionItem)) {
          _this.actions.stateGo('^.remove', {
            childSubscriptionId: subscriptionItem.Id
          });
        } else {
          _this.actions.stateGo('^.remove');
        }
        break;
      case SubscriptionConstants.REMOVE_SUBSCRIPTION_OFFER_OPTION_ID:
        $state.go('index.customercare.customer.removeoffer', {
          offeringId: _this.state.currentSubscription.OfferingId,
          subscriptionId: _this.state.currentSubscription.Id,
          currency: _this.state.currency
        });
        break;
      case SubscriptionConstants.REMOVE_SUBSCRIPTION_EXTENSION_OPTION_ID:
        _this.removeExtensionModalApi.open();
        break;
      case SubscriptionConstants.MODIFY_SUBSCRIPTION_OFFER_OPTION_ID:
        _this.actions.startEditOfferFlow(_this.state.currentSubscription.DisplayName);
        $state.go('index.customercare.customer.orders.editoffer', {
          offeringId: _this.state.currentSubscription.OfferingId,
          offeringInstanceId: _this.state.currentSubscriptionOfferingDetails.OfferingInstanceId
        });
        break;
      case SubscriptionConstants.REPLACE_SUBSCRIPTION_OPTION_ID:
        if (!isNil(subscriptionItem)) {
          _this.actions.stateGo('^.replace', {
            childSubscriptionId: subscriptionItem.Id
          });
        } else {
          _this.actions.stateGo('^.replace');
        }
        break;
      case SubscriptionConstants.VIEW_PAYMENT_HISTORY_OPTION_ID:
        _this.actions.showSubscriptionBanner(true);
        _this.actions.setLockerFilter(_this.state.currentSubscription.Items[0].Id);
        $state.go('index.customercare.customer.transactions.list', {
          previousRoute: {
            name: _this.state.routeState.name,
            params: _this.state.routeParams
          },
          subscription: _this.state.currentSubscription
        });
        break;
      case SubscriptionConstants.MODIFY_RENEWAL_OPTION_ID:
        _this.openRenewalModal(subscriptionItem);
        break;
      default:
        break;
    }
  };
  this.handleMoreOptionClickedOnItem = function (moreOptionItemClicked, subscriptionItem) {
    // the options at the item level will not work as expected until hardcoding when entering flow is removed
    _this.handleMoreOptionsSelected(moreOptionItemClicked, subscriptionItem);
  };
  this.closeEditModal = function () {
    _this.showEditModal = false;
    _this.actions.setEditSubscriptionItemId(null);
  };
  this.restoreSubscription = function () {
    _this.actions.goToCheckoutForRestoreSubscription();
  };
  this.onAddressSwitcherCreateOrEditCallback = function (selectedAddress) {
    _this.handleUpdateSubscription(selectedAddress, true);
  };
  this.onAddressSwitcherChangeCallback = function (selectedAddress) {
    // eslint-disable-next-line no-prototype-builtins
    _this.handleUpdateSubscription(selectedAddress.hasOwnProperty('asMutable') ? selectedAddress.asMutable() : selectedAddress, false);
  };
  this.handleUpdateSubscription = function (selectedAddress, retrieveAddresses) {
    var FilledOrEmptyShipToName = selectedAddress.ShipToName ? selectedAddress.ShipToName : null;
    var updatedSubscription = _this.state.currentSubscription.set('IncludeInactiveDiscounts', true).set('Items', _this.state.currentSubscription.Items.map(function (item) {
      selectedAddress.ShipToName = FilledOrEmptyShipToName;
      return item.set('ShippingAddress', selectedAddress);
    }));
    if (retrieveAddresses) {
      _this.retrieveAddresses().then(function () {
        _this.updateSubscription(updatedSubscription);
      });
    } else {
      _this.updateSubscription(updatedSubscription);
    }
  };
  this.applyDiscount = function (discountData) {
    _this.closeDiscountDialog();
    var discountIds = filter(function (discountMapId) {
      return discountData.selectedDiscounts[discountMapId];
    }, keys(discountData.selectedDiscounts));
    var request = {
      Id: _this.state.subscriptionId,
      DiscretionaryDiscounts: discountIds,
      DiscretionaryDiscountReasonCode: discountData.discountReason.id,
      IncludeInactiveDiscounts: true
    };
    return _this.updateSubscription(request).then(function () {
      return _this.retrieveSubscription();
    });
  };
  this.closeDiscountDialog = function () {
    _this.applyDiscountDialogApi.close();
  };
  this.openDiscountDialog = function () {
    _this.applyDiscountDialogApi.open();
  };
  this.hasSubscriberAdminAccess = function () {
    return PermissionService.hasAdminAccess(_this.state.userSecurityAttributes, E_WALLET_ADMIN_ACCESS);
  };
  this.hasOrderingAccess = function () {
    return PermissionService.hasAdminAccess(_this.state.userSecurityAttributes, ORDERING_ACCESS);
  };
  this.$onDestroy = function () {
    _this.actions.setCurrentSubscriptionOfferingDetails(null);
    disconnectRedux();
  };
  this.onPaymentSwitcherChangeCallback = function (paymentInstrument) {
    _this.actions.selectPaymentMethod(paymentInstrument);
    var data = {
      Id: _this.state.subscriptionId,
      PaymentInstrument: paymentInstrument,
      IncludeInactiveDiscounts: true
    };
    _this.updateSubscription(data);
  };
  this.isLoading = function () {
    return _this.state.isFetchingData || _this.state.isUpdatingSubscription || _this.state.isFetchingEwalletData || _this.state.isFetchingAddresses || _this.state.IsRetrievingPendingOrder || _this.state.isFetchingSingleProductContext || _this.state.isFetchingSubscriptionDetailsSelector;
  };
  this.retrieveAddresses = function () {
    return _this.actions.retrieveCustomerAddresses(_this.state.currentCustomerId, false).catch(function () {
      if (_this.state.addressError) {
        uiNotificationService.transientError(_this.state.addressError.message);
      }
    });
  };
  this.retrieveSubscription = function () {
    var request = {
      IncludeInactiveDiscounts: true,
      IncludeChangeOptions: true
    };
    if (_this.state.offerId) {
      request.OfferingId = _this.state.offerId;
    } else {
      request.Id = _this.state.subscriptionId;
    }
    return _this.actions.retrieveSubscription(_this.state.currentCustomerId, request).then(function () {
      _this.actions.retrieveWallet({
        customerId: _this.state.currentCustomerId
      }).then(function () {
        _this.actions.selectPaymentMethod(_this.state.currentSubscription.PaymentInstrument);
        _this.setInstanceProperties();
      }).catch(function () {
        if (_this.state.eWalletError) {
          uiNotificationService.transientError(_this.state.eWalletError.message);
        }
      });
    }).catch(function () {
      if (_this.state.subscriptionError) {
        uiNotificationService.transientError(_this.state.subscriptionError.message);
      }
    });
  };
  this.setInstanceProperties = function () {
    var productIds = [];
    _this.state.subscriptionItems.forEach(function (item) {
      if (item.InstanceProperties) {
        productIds.push(item.Product.Id);
      }
      if (item.Children) {
        item.Children.forEach(function (childItem) {
          if (childItem.InstanceProperties) {
            productIds.push(childItem.Product.Id);
          }
        });
      }
    });
    if (productIds.length > 0) {
      _this.actions.getProductMetadataBatch(productIds).catch(function () {
        if (_this.state.productOrderError) {
          uiNotificationService.transientError(_this.state.productOrderError.message);
        }
      });
    }
  };
  this.updateSubscription = function (data) {
    return _this.actions.updateSubscription(_this.state.currentCustomerId, data).then(function () {
      _this.uiNotificationService.transientSuccess(i18n.translate(_this.localeKeys.SUBSCRIPTIONS.UPDATE_SUCCESS));
    }).catch(function () {
      if (_this.state.subscriptionError) {
        uiNotificationService.transientError(_this.state.subscriptionError.message);
      }
    });
  };
  this.cancelPendingOrder = function () {
    return _this.actions.cancelPendingOrder(_this.state.currentCustomerId, {
      'OrderId': _this.state.currentSubscription.PendingOrderId
    });
  };
  this.applySubscriptionCoupon = function () {
    var customerId = _this.state.currentCustomerId;
    var subscriptionId = _this.state.subscriptionId;
    var couponName = _this.state.couponCode.name;
    return _this.actions.applySubscriptionCoupon(customerId, subscriptionId, couponName).then(function () {
      _this.uiNotificationService.transientSuccess(i18n.translate(_this.localeKeys.SUBSCRIPTIONS.UPDATE_SUCCESS));
      return _this.retrieveSubscription();
    }, function (payload) {
      uiNotificationService.transientError(payload.translatedMessage);
    });
  };
  this.displayInnerHeading = function () {
    return _this.state.showShippingInfo ? "".concat(i18n.translate(_this.localeKeys.SUBSCRIPTIONS.PAYMENT_SHIPPING_INFO)) : "".concat(i18n.translate(_this.localeKeys.SUBSCRIPTIONS.PAYMENT_INFO));
  };
  this.openRenewalModal = function (subscriptionItem) {
    _this.actions.setModifyRenewalSubscriptionItem(subscriptionItem || null);
    _this.toggleModifyRenewalModal = true;
    $timeout(function () {
      _this.modifyRenewalModal.open();
    });
  };
  this.openCancelRemovalModal = function () {
    _this.cancelRemovalModalApi.open();
  };
  this.openCancelChangeModal = function () {
    _this.actions.retrievePendingOrder(_this.state.currentCustomerId, {
      'OrderId': _this.state.currentSubscription.PendingOrderId
    }).then(function () {
      _this.cancelChangeModalApi.open();
    }).catch(function (error) {
      _this.uiNotificationService.transientError(error.translatedMessage);
    });
  };
  this.closeRenewalModal = function () {
    _this.modifyRenewalModal.close();
    _this.toggleModifyRenewalModal = false;
  };
  this.onRenewSuccess = function () {
    _this.closeRenewalModal();
    _this.toggleModifyRenewalModal = false;
  };
  this.closeCancelChangeModal = function () {
    _this.cancelChangeModalApi.close();
  };
  this.closeCancelRemovalModal = function () {
    _this.cancelRemovalModalApi.close();
  };
  this.onCancelRemovalChangeSuccess = function () {
    if (_this.isPendingChange()) {
      _this.closeCancelChangeModal();
    } else {
      _this.closeCancelRemovalModal();
    }
    _this.cancelPendingOrder().then(function () {
      if (_this.isPendingChange()) {
        _this.uiNotificationService.transientSuccess(i18n.translate(_this.localeKeys.CHANGE_OFFER.CHANGE_OFFER_SUCCESS));
        _this.actions.stateGo(DASHBOARD_ROUTE);
      } else {
        _this.uiNotificationService.transientSuccess(i18n.translate(_this.localeKeys.SUBSCRIPTIONS.CANCEL_REMOVAL_SUCCESS));
        _this.retrieveSubscription();
      }
    }).catch(function (error) {
      _this.uiNotificationService.transientError(error.translatedMessage);
    });
  };
  this.canCreatePaymentInstruments = function () {
    return _this.state.currentMemberCanCreatePaymentInstrument && _this.hasSubscriberAdminAccess();
  };
  this.openRemoveDiscountModal = function () {
    _this.showDiscountRemove = true;
    $timeout(function () {
      _this.removeDiscountModal.open();
    });
  };
  this.closeRemoveDiscountModal = function () {
    _this.showDiscountRemove = false;
    _this.actions.setSelectedDiscount({});
    _this.removeDiscountModal.close();
  };
  this.onDiscountChange = function (discount) {
    _this.actions.setSelectedDiscount(discount);
  };
  this.onRemoveDiscount = function (discount) {
    var updatedObject = Object.assign({}, discount, {
      Reason: null
    });
    _this.actions.setSelectedDiscount(updatedObject);
    _this.openRemoveDiscountModal();
  };
  this.removeDiscount = function () {
    return _this.actions.removeSubscriptionDiscount(_this.state.currentCustomerId, _this.state.selectedDiscount.Id, _this.state.selectedDiscount.Reason).then(function () {
      _this.closeRemoveDiscountModal();
      uiNotificationService.transientSuccess(i18n.translate(_this.localeKeys.SUBSCRIPTIONS.REMOVE_DISCOUNT.SUCCESS));
      return _this.retrieveSubscription();
    }).catch(function () {
      uiNotificationService.transientError(_this.state.subscriptionError.message);
    });
  };
  this.onSubscriptionExtensionRemoveListComplete = function (extensionId) {
    _this.removeExtensionModalApi.close();
    _this.actions.stateGo('index.customercare.customer.subscriptions.detail.extension', {
      extensionId: extensionId,
      currency: _this.state.currency
    });
  };
  this.closeSubscriptionExtensionRemoveListPopup = function () {
    _this.removeExtensionModalApi.close();
  };
  this.getRenewalText = function () {
    if (_this.isCurrentPaymentMethodRemoved()) {
      return _this.willNotRenew;
    }
    return _this.state.currentSubscription.Type === SubscriptionConstants.SUBSCRIPTION_TYPE.MANUAL ? _this.manualRenewal : _this.autoRenewal;
  };
  this.isReadOnly = function () {
    if (_this.state.currentSubscription && (_this.state.currentSubscription.Status === SubscriptionConstants.SUBSCRIPTION_STATUSES.SUSPENDED || _this.state.currentSubscription.Status === SubscriptionConstants.SUBSCRIPTION_STATUSES.REMOVED || _this.state.currentSubscription.Status === SubscriptionConstants.SUBSCRIPTION_STATUSES.PENDING_REMOVAL || _this.state.IsCurrentSubscriptionOfferingPending)) {
      return true;
    }
    var selectedPaymentMethodType = pathOr('', ['Type'], _this.state.selectedPaymentMethod);
    var readOnlyException = isReadOnlyException(selectedPaymentMethodType);
    if (readOnlyException) {
      return false;
    } else {
      return _this.state.selectedPaymentMethod && !_this.state.selectedPaymentMethod.actionables.canOrder;
    }
  };
  this.redirectToOrderDetails = function (id) {
    _this.actions.stateGo('index.customercare.customer.orderHistory.details', {
      orderId: id,
      previousRoute: {
        name: _this.state.routeState.name,
        params: _this.state.routeParams
      },
      subscription: _this.state.currentSubscription
    });
  };
  this.isCurrentPaymentMethodRemoved = function () {
    if (!_this.state.selectedPaymentMethod) {
      return;
    }
    return _this.state.selectedPaymentMethod.Status === SubscriptionConstants.PAYMENT_METHOD_STATUSES.REMOVED;
  };
  this.getExistingOfferTitle = function () {
    if (!_this.state.IsRetrievingPendingOrder && _this.state.pendingOrder) {
      return i18n.translate(_this.localeKeys.CHANGE_OFFER.EXISTING_OFFER, {
        offeringName: pathOr('', ['pendingOrder', 'ExistingOfferings', '0', 'OfferingName'], _this.state) || _this.state.currentSubscription.displayName
      });
    }
  };
  this.getNewOfferTitle = function () {
    if (!_this.state.IsRetrievingPendingOrder && _this.state.pendingOrder) {
      return i18n.translate(_this.localeKeys.CHANGE_OFFER.NEW_OFFER, {
        offeringName: pathOr('', ['pendingOrder', 'NewOfferings', '0', 'OfferingName'], _this.state) || _this.state.currentSubscription.displayName
      });
    }
  };
  this.getMaxChangeItemsRange = function () {
    return range(0, max(pathOr(0, ['NewOfferings', '0', 'OrderItems', 'length'], _this.state.pendingOrder), pathOr(0, ['ExistingOfferings', '0', 'OrderItems', 'length'], _this.state.pendingOrder)));
  };
  this.isPendingRemoval = function () {
    return pathOr(false, ['currentSubscriptionOfferingDetails', 'Status'], _this.state) === OFFERING_OPTION_STATUSES.PENDING_REMOVED;
  };
  this.isPendingChange = function () {
    return _this.state.IsCurrentSubscriptionOfferingPending && !_this.isPendingRemoval();
  };
}
export default {
  bindings: {},
  template: require('./subscriptions.detail.html'),
  controller: SubscriptionDetailController,
  controllerAs: 'subscriptionDetailController'
};